module.exports = __webpack_public_path__ + "img/buy.66b2bc8c.png";